class ReportLimits {
    get reportLimit() {
        return this._reportLimit;
    }

    set reportLimit(reportLimit) {
        this._reportLimit = reportLimit;
    }

    get reportsUsed() {
        return this._reportsUsed;
    }

    set reportsUsed(reportsUsed) {
        this._reportsUsed = reportsUsed;
    }

    get remaining() {
        return this._remaining;
    }

    set remaining(remaining) {
        this._remaining = remaining;
    }

    get endDate() {
        return this._endDate;
    }

    set endDate(endDate) {
        this._endDate = endDate;
    }

    get subscriptionPlan() {
        return this._subscriptionPlan;
    }

    set subscriptionPlan(subscriptionPlan) {
        this._subscriptionPlan = subscriptionPlan;
    }

    get canDownload() {
        return this._canDownload;
    }

    set canDownload(canDownload) {
        this._canDownload = canDownload;
    }

    get error() {
        return this._error;
    }

    set error(error) {
        this._error = error;
    }
}

export default ReportLimits;
